/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_Pain_2Inputs */

const en_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in a language you're comfortable with`)
};

const de_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht in einer vertrauten Sprache`)
};

const zh_tw_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是自己熟悉的語言`)
};

const zh_cn_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是自己熟悉的语言`)
};

const es_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No están en un idioma que te resulte familiar`)
};

const fr_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas dans une langue familière`)
};

const it_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sono in una lingua familiare`)
};

const pt_br_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem sempre tá num idioma que você domina`)
};

const ja_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の慣れた言語じゃない`)
};

const ko_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`익숙하지 않은 언어라 부담되고`)
};

const ru_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент не на понятном языке`)
};

const th_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ใช่ภาษาที่คุ้นเคย`)
};

const tr_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aşina olduğun dilde değil`)
};

const ar_problem_pain_2 = /** @type {(inputs: Problem_Pain_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليست بلغة مألوفة لك`)
};

/**
* | output |
* | --- |
* | "Not in a language you're comfortable with" |
*
* @param {Problem_Pain_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_pain_2 = /** @type {((inputs?: Problem_Pain_2Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_Pain_2Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_pain_2(inputs)
	if (locale === "de") return de_problem_pain_2(inputs)
	if (locale === "zh_tw") return zh_tw_problem_pain_2(inputs)
	if (locale === "zh_cn") return zh_cn_problem_pain_2(inputs)
	if (locale === "es") return es_problem_pain_2(inputs)
	if (locale === "fr") return fr_problem_pain_2(inputs)
	if (locale === "it") return it_problem_pain_2(inputs)
	if (locale === "pt_br") return pt_br_problem_pain_2(inputs)
	if (locale === "ja") return ja_problem_pain_2(inputs)
	if (locale === "ko") return ko_problem_pain_2(inputs)
	if (locale === "ru") return ru_problem_pain_2(inputs)
	if (locale === "th") return th_problem_pain_2(inputs)
	if (locale === "tr") return tr_problem_pain_2(inputs)
	return ar_problem_pain_2(inputs)
});